namespace GeniuzPOS.Purchase {
    export namespace PoPo06DtPendingCNforCnrtvService {
        export const baseUrl = 'Purchase/PoPo06DtPendingCNforCnrtv';

        export declare function Create(request: Serenity.SaveRequest<PoPo06DtPendingCNforCnrtvRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PoPo06DtPendingCNforCnrtvRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PoPo06DtPendingCNforCnrtvRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PoPo06DtPendingCNforCnrtvRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Purchase/PoPo06DtPendingCNforCnrtv/Create",
            Update = "Purchase/PoPo06DtPendingCNforCnrtv/Update",
            Delete = "Purchase/PoPo06DtPendingCNforCnrtv/Delete",
            Retrieve = "Purchase/PoPo06DtPendingCNforCnrtv/Retrieve",
            List = "Purchase/PoPo06DtPendingCNforCnrtv/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PoPo06DtPendingCNforCnrtvService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
